

export enum OfficeEventType {
    WORKSHOP = "Workshop",
    PHONE_JAM = "Phone Jam",
    CONFERENCE = "Conference",
    TEAM_MEETING = "Team Meeting",
    CUSTOM = "Custom"
}